
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search : ''

    // pagination
    const page = data.page ? data.page : 1

    // field query
    const fieldquery = data.fieldquery ? '&field_query=' + JSON.stringify(data.fieldquery) : ''

    return axios.get(process.env.API_ENDPOINT + '/class?token=' + VueCookies.get('token') + '&page=' + page + search + fieldquery + limit)
  },
  getClassesCalendar (data) {
    // field query
    const fieldquery = data.fieldquery ? '&field_query=' + JSON.stringify(data.fieldquery) : ''

    return axios.get(process.env.API_ENDPOINT + '/classcalendar?token=' + VueCookies.get('token') + fieldquery)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/class?token=' + VueCookies.get('token'), data)
  },
  clone (data) {
    return axios.post(process.env.API_ENDPOINT + '/clone-class?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/class/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/class/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/class/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/classes.js